'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _upperFirst = require('lodash/upperFirst');var _upperFirst2 = _interopRequireDefault(_upperFirst);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _getLocalizedData2 = require('../../utils/getLocalizedData');var _getLocalizedData3 = _interopRequireDefault(_getLocalizedData2);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _HomePageCitiesLinks = require('./HomePageCitiesLinks.scss');var styles = _interopRequireWildcard(_HomePageCitiesLinks);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

HomePageCitiesLinks = function (_Component) {_inherits(HomePageCitiesLinks, _Component);function HomePageCitiesLinks() {var _temp, _this, _ret;_classCallCheck(this, HomePageCitiesLinks);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isHidden: true }, _this.


    handleOpen = function () {return _this.setState({ isHidden: false });}, _this.
    handleHide = function () {return _this.setState({ isHidden: true });}, _this.

    concatTitle = function (optionType) {
      var translate = _this.props.translate('SEOsearch');
      var realEstateApartments = translate('realEstateApartments');
      var forOption = translate('optionType', optionType);
      var inCity = translate('in');
      var citiesOfIsrael = translate('citiesOfIsrael');

      var title = realEstateApartments + ' ' + forOption + ' ' + inCity + citiesOfIsrael;
      return (0, _upperFirst2.default)(title);
    }, _this.

    renderLinks = function () {return _this.props.citiesData.map(function (item, idx) {var _cx;var
        optionType = _this.props.optionType;var _getLocalizedData =
        (0, _getLocalizedData3.default)(item.localisation, _this.props.locale),name = _getLocalizedData.result;
        var translate = _this.props.translate('SEOsearch');

        var content = translate('apartments') + ' ' + translate('optionType', optionType) + ' ' + translate('in') + name;

        return (
          _react2.default.createElement(_reactRouter.Link, {
              to: (0, _appendLocale2.default)(_this.props.locale, '/homes/' + optionType + '/' + item.name),
              className: (0, _classnames2.default)(styles.link, (_cx = {}, _cx[styles.hiddenLink] = idx > 7 && _this.state.isHidden, _cx)),
              key: item.name },

            content));


      });}, _this.

    renderButton = function (text, handler) {return (
        _react2.default.createElement('button', { key: 'more_button', className: styles.moreButton, onClick: handler },
          _react2.default.createElement('span', null, (0, _upperFirst2.default)(_this.props.translate('SEOsearch', text))), '\xA0\xA0', _react2.default.createElement('span', { className: 'icon icon-arrow-' + (text === 'showMore' ? 'down' : 'up') })));}, _temp), _possibleConstructorReturn(_this, _ret);}HomePageCitiesLinks.prototype.



  render = function render() {var _cx2;
    var links = this.renderLinks();
    var moreButton = this.renderButton('showMore', this.handleOpen);
    var hideButton = this.renderButton('hide', this.handleHide);

    if (this.state.isHidden) {
      links.splice(8, 0, moreButton);
    }

    return (
      _react2.default.createElement('div', { className: styles.linksContainer },
        _react2.default.createElement('div', { className: styles.title }, this.concatTitle(this.props.optionType)),
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.links, (_cx2 = {}, _cx2[styles.hidden] = this.state.isHidden, _cx2)) },
          links,
          !this.state.isHidden && hideButton)));



  };return HomePageCitiesLinks;}(_react.Component);



HomePageCitiesLinks.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  citiesData: _propTypes2.default.array,
  optionType: _propTypes2.default.string };exports.default =


HomePageCitiesLinks;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePageCitiesLinks/HomePageCitiesLinks.js
// module id = 2693
// module chunks = 0